module.exports = __webpack_public_path__ + "img/shield-fail.a0224e87.svg";